/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_8f020e0e"]'><div><cube-button @_click="showPickerWithUpdate">Use updateData</cube-button><cube-picker-modal ref="__mpx_ref_picker__" title="更新数据" :list="(dataList)" :selected-index="(selectedIndex)"/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_8f020e0e"}'>
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_8f020e0e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_8f020e0e"}
  /** script content **/
  require("./update-data-picker.mpx.js?isComponent&outputPath=components%2Fupdate-data-picker8f020e0e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./update-data-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fupdate-data-picker8f020e0e%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_8f020e0e"],
    ctorType: "component",
    outputPath: "components/update-data-picker8f020e0e/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-picker-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/picker-modal/index.mpx?isComponent&outputPath=components%2Findexa989b916%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>